<template>
  <div>
    <BaseModal
      :showing="visible"
      size="max-w-5xl"
      @opened="onOpened"
      @close="$emit('close')"
    >
      <div class="space-y-6">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-4">
            <div>
              <h3 class="text-lg font-bold leading-6 text-gray-900">
                Daftar Barang Faktur
              </h3>
              <p class="mt-1 max-w-2xl text-sm text-gray-500">
                Daftar barang faktur penjualan dan pembelian
              </p>
            </div>
          </div>
        </div>
        <div class="space-y-4 border-t border-gray-200 pt-6">
          <div class="flex justify-end gap-x-2">
            <BaseSelect
              placeholder="Cari Barang"
              :shadow="false"
              :options="[
                { key: 'reguler', label: 'Barang Reguler', value: 'reguler' },
                { key: 'free', label: 'Barang Free', value: 'free' }
              ]"
              v-model="filter.type"
              @change="loadOrderDetails"
            />
            <BaseInput
              placeholder="Cari Barang"
              type="search"
              :shadow="false"
              debounce
              v-model="filter.search"
              @native-input="loadOrderDetails"
            />
          </div>
          <datatable
            :columns="tableColumns"
            :scroll-x="false"
            :total="orderDetails.meta.page.total"
            :perPage="orderDetails.meta.page.perPage"
            :currentPage="orderDetails.meta.page.currentPage"
            @pagechanged="onPagechanged"
          >
            <template v-slot:tbody="{ classes }">
              <tr
                v-for="orderDetail in orderDetails.data"
                :key="orderDetail.id"
                :class="[
                  classes.tr,
                  'cursor-pointer bg-white hover:bg-green-100',
                ]"
                @click="onClickOrderDetail(orderDetail)"
              >
                <td :class="[classes.td]">
                  <p class="font-bold text-gray-900">
                    {{ orderDetail.attributes.product_code }}
                    <span v-if="orderDetail.type === 'order-detail-bonuses'">(FREE)</span>
                  </p>
                </td>
                <td :class="[classes.td]">
                  {{ orderDetail.attributes.product_name }}
                </td>
                <td :class="[classes.td]">
                  {{ orderDetail.attributes[orderDetail.type === 'order-details' ? 'product_received' : 'bonus_received'] }}
                </td>
                <td :class="[classes.td]">
                  {{ orderDetail.attributes[orderDetail.type === 'order-details' ? 'product_returned_qty' : 'bonus_returned_qty'] }}
                </td>
                <td :class="[classes.td]">
                  {{ orderDetail.attributes.current_stock }}
                </td>
              </tr>
            </template>
          </datatable>
        </div>
      </div>
    </BaseModal>
    <loading v-if="loading" />
  </div>
</template>

<script>
import BaseModal from '@/components/base/BaseModal';
import { requestMixin } from '@/mixins/request/request';
import { mapGetters } from 'vuex';

export default {
  components: {
    BaseModal,
  },
  mixins: [requestMixin],
  props: {
    visible: Boolean,
    requestParams: null,
    columns: {
      type: Array,
      default: () => ['code'],
    },
    orderId: String,
  },
  emits: ['close', 'click-order-detail'],
  data() {
    return {
      orderDetails: {
        data: [],
        meta: {
          page: {},
        },
      },
      loading: false,
      filter: {
        search: null,
        type: 'reguler'
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
    tableColumns() {
      return [
        {
          id: 'code',
          name: 'Kode Barang',
        },
        {
          id: 'name',
          name: 'Nama Barang',
        },
        {
          id: 'received_qty',
          name: 'Jumlah Diterima',
        },
        {
          id: 'product_returned_qty',
          name: 'Jumlah Diretur',
        },
        {
          id: 'stok',
          name: 'Stok',
        },
      ].filter((item) => !!item);
    },
  },
  methods: {
    async loadOrderDetails(params) {
      this.loading = true;

      const orderDetailFields = [
        'product_code',
        'product_name',
        'product_id',
        'product_received',
        'current_stock',
        'product_returned_qty',
      ].join(',');

      const [res, error] = await this.request(
        `/api/v1/orders/${this.orderId}/${this.filter.type === 'reguler' ? 'order-details' : 'order-detail-bonuses'}`,
        {
          params: {
            ...this.requestParams,
            'page[size]': 5,
            'fields[order-details]': orderDetailFields,
            'fields[order-detail-bonuses]': 'product_code,product_name,product_id,bonus_received,current_stock,bonus_returned_qty',
            'filter[search]': this.filter.search,
            ...params,
          },
        }
      );

      if (!error) {
        this.orderDetails = res;
      }

      this.loading = false;
    },
    onClickOrderDetail(orderDetail) {
      this.$emit('click-order-detail', orderDetail);
    },
    onOpened() {
      this.filter.type = 'reguler'
      this.filter.search = null;

      this.loadOrderDetails();
    },
    onPagechanged(page) {
      this.loadOrderDetails({
        'page[number]': page,
      });
    },
  },
};
</script>
